// @flow
import { all, fork, put, takeLatest, call } from 'redux-saga/effects';

import {
    getAllIntegrationTypes as getAllIntegrationTypesApi,
} from '../../helpers/';

import { integrationTypesApiResponseSuccess, integrationTypesApiResponseError } from './actions';
import { IntegrationTypesActionTypes } from './constants';
import { integrationTypeToIntegrationTypeObject } from '../../helpers/mappers/integrationType';
import { addToast } from '../actions';

function* getAllIntegrationTypes({ payload: { query } }) {
    try {
        const getAllIntegrationTypesResponse = yield call(getAllIntegrationTypesApi, query);
        const integrationTypes = getAllIntegrationTypesResponse.data.map((integrationType) =>
            integrationTypeToIntegrationTypeObject(integrationType)
        );
        yield put(integrationTypesApiResponseSuccess(IntegrationTypesActionTypes.GET_ALL_INTEGRATION_TYPES, { integrationTypes }));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(integrationTypesApiResponseError(IntegrationTypesActionTypes.GET_ALL_INTEGRATION_TYPES, error));
    }
}

export function* watchGetAllIntegrationTypes(): any {
    yield takeLatest(IntegrationTypesActionTypes.GET_ALL_INTEGRATION_TYPES, getAllIntegrationTypes);
}

function* getAllIntegrationTypesSaga(): any {
    yield all([fork(watchGetAllIntegrationTypes)]);
}

export default getAllIntegrationTypesSaga;
